export default __webpack_public_path__ + "static/media/Shemite Wayfarer Tunic.efd7d5cc.jpg";